import request from '@/utils/request'
import type {
  WeComBindingConfirmParams,
  WeComBindingConfirmResult,
  WeComBindingReturnStatusParams,
  WeComBindingReturnStatusResult,
  WeComQrCodeCreateParams,
  WeComQrCodeCreateResult,
} from '@/types/wecom'

const weComUrl = '/commonfacade/wecom'

export const createWeComQrCode = (data: WeComQrCodeCreateParams) => {
  return request.post<WeComQrCodeCreateResult>(`${weComUrl}/qrcode/create`, data, { silent: true })
}

export const confirmWeComBinding = (data: WeComBindingConfirmParams) => {
  return request.post<WeComBindingConfirmResult>(`${weComUrl}/binding/confirm`, data, { silent: true })
}

export const getWeComBindingReturnStatus = (data: WeComBindingReturnStatusParams) => {
  return request.post<WeComBindingReturnStatusResult>(`${weComUrl}/binding/return/check`, data, { silent: true })
}
